import styled from 'styled-components';

export const DescriptionInputWrapper = styled.div`
  grid-column: 1/3;
`;
